
export default [
    {
        path: '/',
        component: resolve => require(['@/components/common/layout.vue'], resolve),
        children: [
            {
                path: '/',
                name: 'Login',
                component: resolve => require(['@/components/pages/login/index'], resolve)
            },
            {
                path: '/register',
                name: 'register',
                component: resolve => require(['@/components/pages/login/components/register/index'], resolve)
            },
            {
              path: '/tip',
              name: 'tip',
              component: resolve => require(['@/components/pages/common/tip'], resolve)
            },
            // {
            //     path: '/',
            //     name: 'Login',
            //     component: resolve => require(['@/components/pages/login/index'], resolve)
            // },
            {
                path: '/userCenter',
                name: 'userCenter',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/usercenter/index'], resolve)
            },
            {
                path: '/questionManage',
                name: 'questionManage',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/questionManage/index'], resolve)
            },
            {
                path: '/recruitManage',
                name: 'recruitManage',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/recruitManage/index'], resolve) // 招募管理
            },
            {
                path: '/createExperiment',
                name: 'createExperiment',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/createExperiment/index'], resolve)
            },
            {
                path: '/shareExperiment',
                name: 'shareExperiment',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/createExperiment/src/shareExperiment/index'], resolve)
            },
            {
                path: '/experimentDetail',
                name: 'experimentDetail',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/experimentDetail/index'], resolve)
            },
            {
                path: '/personDeatail',
                name: 'personDeatail',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/personDeatail/index'], resolve)
            },
            {
                path: '/sharewx',
                name: 'sharewx',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/sharewx.vue'], resolve)
            },
            {
                path: '/share',
                name: 'share',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['@/components/pages/share.vue'], resolve)
            },
        ]
    },

  {
    path: '/userAgreement',
    component: resolve => require(['@/components/pages/userAgreement/index'], resolve)
  },

];



// WEBPACK FOOTER //
// ./src/router/routers.js